export default "__VITE_ASSET__DfOoElr$__"